<div (click)="open('/main/unassigned-tags')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    <div class="d-flex justify-content-between">
        <div class="fs-main fw-bold mb-3">Tags not yet assigned to animals</div>
        <div class="mt-auto mb-auto">
            <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
        </div>
    </div>
    @let unassignedTags = deviceStore.unassignedTags();
    @if (unassignedTags.length > 0) {
        <img src="icons/tag.svg" class="icon"/>
        <span class="p-2">{{ unassignedTags.length }}</span>
    }
</div>
